export default __webpack_public_path__ + "static/RDBGroup-5da9a17e608e812c414f9581f8b8dff4.svg";